import { useTranslator } from '@bluebeam/react-i18n';
import ProviderFileBrowser from 'components/FileBrowser/ProviderFileBrowser';
import NewFolderDropdownButton from 'components/modals/ExportDataModal/NewFolderDropdownButton';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ConnectedAccount } from 'records/ConnectedAccount';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends RouteComponentProps, WithAppStoreProps {}
const IntegrationsBrowseFilesStep: React.FC<Props> = (props: Props) => {
  const { appState, history, actions } = props;
  const [selectedAccount, setSelectedAccount] = useState<ConnectedAccount>(
    new ConnectedAccount()
  );
  const { translate } = useTranslator(['requestDownloadModal']);

  useEffect(() => {
    (async () => {
      const connectedAccount = appState.getSelectedConnectedAccount();
      if (connectedAccount) {
        setSelectedAccount(connectedAccount);
      } else {
        history.push(`/project/${appState.selectedProject}/settings`);
        actions.clearAllModals();
      }
    })();
  }, []);
  return (
    <>
      <div className="column px5 pt9 bb-2 pb3">
        <div className="color-black-2 font-size-7 medium">
          {translate('requestDownloadModal:exportModal.browseFilesStep.title')}
        </div>
        <div className="color-black-1 pt2 font-size-5 pb1 light">
          {translate(
            'requestDownloadModal:exportModal.browseFilesStep.content'
          )}
        </div>
      </div>
      <div className="row px5 pt4 justify-between items-center">
        <div className="color-black-2 font-size-5">
          {translate(
            'requestDownloadModal:exportModal.browseFilesStep.selectedFolders',
            {
              folderCount: appState.integrationsSelectedItems.count(),
            }
          )}
        </div>
        <NewFolderDropdownButton into="integrations" />
      </div>
      <div className="h100 px5 pb8">
        <div className="oh" style={{ height: '48vh', paddingBottom: '60px' }}>
          {selectedAccount.id && (
            <ProviderFileBrowser
              providerType={selectedAccount.providerType}
              connectionId={selectedAccount.id}
              singleSelect
              onlyFolders
            />
          )}
        </div>
      </div>
    </>
  );
};

export default withRouter(withAppStore<Props>(IntegrationsBrowseFilesStep));
